// 3D 畫面「存美術圖」的檔名（不含副檔名）：曲序_歌曲名稱_日期，例：S02_夜空_20261104
//   曲序   有歌曲代號用代號，否則用歌單順序兩位數（01、02…）
//   歌名   已經以同一個代號開頭就不重複；Windows / Mac 不能用的字換成「-」，頭尾空白去掉
//   日期   使用者當地時間的 YYYYMMDD
// 純函式，不碰畫面；artImageName.test.ts 有測。

/** Windows（\ / : * ? " < > |）和控制字元、Mac 的 ":" 都換成 -；頭尾空白、句點去掉 */
export function safeFileSegment(raw: string): string {
  return String(raw ?? '')
    // eslint-disable-next-line no-control-regex
    .replace(/[\\/:*?"<>|\u0000-\u001f]/g, '-')
    .replace(/^[\s.]+|[\s.]+$/g, '');
}

export function artImageDate(now: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}${p(now.getMonth() + 1)}${p(now.getDate())}`;
}

export interface ArtImageSong { id: string; name: string; code?: string | null }

/** 檔名（不含 .png）；沒選歌（song 是空的）→ null */
export function artImageName(song: ArtImageSong | null | undefined, songs: ArtImageSong[], now: Date = new Date()): string | null {
  if (!song) return null;
  const code = safeFileSegment(song.code ?? '');
  let seq = code;
  if (!seq) {
    const idx = songs.findIndex(s => s.id === song.id);
    seq = String((idx >= 0 ? idx : 0) + 1).padStart(2, '0');
  }
  let name = safeFileSegment(song.name);
  if (code) {
    const lower = name.toLowerCase();
    const c = code.toLowerCase();
    if (lower.startsWith(c) && (lower.length === c.length || !/[a-z0-9]/.test(lower[c.length]))) {
      name = name.slice(code.length).replace(/^[\s\-_:：.]+/, '');
    }
  }
  return [seq, name, artImageDate(now)].filter(Boolean).join('_');
}
